import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/play-fill.svg'
import _imports_1 from '@/assets/icons/solid/playlist-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import { // api
		getSceneSongsByRecordId
	} from '../../../../queries'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import {  // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { // vue
		onMounted,
		ref
	} from 'vue'	
	
	
	const __default__ = { name: 'SceneSoundScores' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		showDetails:{
			type: Function,
			default: () => {return}
		},
		song: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()
	const userStore = _userStore()

	const {t} = useI18n()

	const songList = ref()
	const loading = ref(true)
	const isStaff = ref(userStore.getContactType === 'Staff')

	onMounted(async () => {
		try { // fetching scene songs by record id
			loading.value = true

			const recordId = props.song.recordId

			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			let res = await getSceneSongsByRecordId(recordId, params)
			const record = res.response.data[0]
			
			songList.value = record.portalData.jobs_songs__JOBS_SONGS_SCORES__jobsSongsID
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false			
		}
	})

	function hasFiles(row: any) {
		return row?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::s3JSONkaraokeM4A'] ||
			row?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::s3JSONscorePDF'] ||
			row?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::s3JSONscoreSONG']
	}

	function hasInstrument(row: any) {
		return row?.['jobs_songs__jobs_scongs_scores__INSTRUMENT_JOBS__jobsSongsScoresID::_kp_instruments_jobs_id']
	}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(null, 'sceneDetails', 5, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToSound")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_tw_table, {
        placeholder: _unref(t)('placeholders.noSongs'),
        data: songList.value,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('183'),
            prop: "jobs_songs__jobs_songs_scores__SCORES__scoreID::name_display"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('125'),
            prop: "jobs_songs__jobs_songs_scores__SCORES__scoreID::key_range"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('510'),
            prop: "jobs_songs__jobs_songs_scores__SCORES__scoreID::version_display"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('190'),
            prop: "jobs_songs__jobs_songs_scores__SCORES__scoreID::description_display"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            "class-name": "w-6",
            "header-class-name": "w-6",
            "align-text": "right"
          }, {
            default: _withCtx(({row}) => [
              _createElementVNode("div", {
                onClick: ($event: any) => (__props.showDetails(row, 'songScoreFiles', null, __props.song)),
                class: "h-6 w-6 cursor-pointer"
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass([hasFiles(row) ? 'linked-icon' : 'grayed-icon']),
                  src: _imports_0,
                  alt: "play icon"
                }, null, 2)
              ], 8, _hoisted_3)
            ]),
            _: 1
          }),
          (isStaff.value)
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 0,
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (__props.showDetails(row, 'songScoreInstruments', null, __props.song)),
                    class: "h-6 w-6 cursor-pointer"
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([hasInstrument(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_1,
                      alt: "music icon"
                    }, null, 2)
                  ], 8, _hoisted_4)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "data", "loading"])
    ])
  ], 64))
}
}

})